module.exports = __webpack_public_path__ + "img/2024-10-16f_3.ae6c31ae.jpg";